const namespace = {
  title: "Facteurs de valeur immobilière",
  description:
    "Ces caractéristiques ont le plus d'impact positif sur les valeurs des maisons dans ce quartier.",
  noData:
    "Découvrez les caractéristiques qui influencent les prix des maisons; cette liste détaille les facteurs qui affectent positivement les valeurs des propriétés dans un {{locationType}}.",
  locationType: {
    neighborhood: "quartier",
    location: "emplacement",
  },
  valueDrivers: {
    bus_service_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence de services d'autobus améliore la connectivité et l'accessibilité d'un {{locationType}}, le rendant plus attrayant pour les navetteurs et augmentant son attractivité globale.",
      },
    },
    shops_and_services_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence de nombreux commerces de proximité facilement accessibles peut augmenter l'attractivité globale d'un {{locationType}}.",
      },
    },
    coffee_shop_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence de cafés à proximité et facilement accessibles peut créer un environnement accueillant et un {{locationType}} plus attrayant.",
      },
    },
    clothing_and_accessory_store_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence de nombreux magasins de vêtements et d'accessoires facilement accessibles à proximité peut accroître la désirabilité globale d'un {{locationType}}.",
      },
    },
    common_needs_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "L'accès facile à des commodités de base comme les quincailleries, bureaux de poste et dépanneurs peut améliorer l'accessibilité des services dans un {{locationType}}.",
      },
    },
    department_store_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence de grands magasins à proximité et facilement accessibles peut augmenter l'attractivité globale d'un {{locationType}}.",
      },
    },
    entertainment_venue_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence de lieux de divertissement facilement accessibles peut être le signe d'un {{locationType}} plus vivant et plus attrayant.",
      },
    },
    fitness_establishment_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence d'établissements de conditionnement physique facilement accessibles, tels que des gymnases, des studios de yoga et des piscines, peut rendre le {{locationType}} plus attrayant.",
      },
    },
    nightlife_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "Un accès facile aux centres locaux de la vie nocturne, tels que les bars, les pubs et les clubs de comédie, peut être le signe d'un {{locationType}} plus dynamique.",
      },
    },
    pedestrian_oriented_street_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence de rues commerciales facilement accessibles, conçues pour être conviviales pour les piétons, peut créer un {{locationType}} plus attrayant.",
      },
    },
    rapid_transit_service_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La proximité de stations de transport en commun rapide à haute fréquence peut être le signe d'un {{locationType}} plus accessible.",
      },
    },
    restaurant_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence de restaurants facilement accessibles et à proximité peut créer un {{locationType}} plus attrayant.",
      },
    },
    specialty_grocery_store_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La présence d'épiceries spécialisées à proximité peut indiquer un {{locationType}} plus attrayant.",
      },
    },
    sports_facility_access: {
      tag: {
        high: "Plusieurs à proximité",
      },
      qualifier: {
        high: "La proximité d'installations sportives telles que des terrains de football, des pistes de course et des patinoires peut rendre le {{locationType}} plus attrayant.",
      },
    },
    train_service_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence de gares à proximité qui ont un service fréquent peut indiquer un {{locationType}} plus accessible.",
      },
    },
    nearest_highway_proximity: {
      tag: {
        high: "Excellent accès",
        low: "Faible densité",
      },
      qualifier: {
        high: "Un accès facile aux grandes autoroutes peut créer un {{locationType}} plus accessible.",
        low: "Peu d'autoroutes à proximité peut rendre le {{locationType}} plus calme et plus attrayant.",
      },
    },
    nearest_pharmacy_proximity: {
      tag: {
        high: "Disponible à proximité",
      },
      qualifier: {
        high: "Un accès facile à une pharmacie à proximité peut indiquer un {{locationType}} plus accessible.",
      },
    },
    nearest_bicycle_share_station_proximity: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence de stations de vélopartage à proximité peut être le signe d'un {{locationType}} plus accessible.",
      },
    },
    bicycle_path_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence de pistes cyclables facilement accessibles peut être le signe d'un {{locationType}} plus accessible et plus attrayant.",
      },
    },
    bicycle_share_station_access: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence de stations de vélopartage à proximité peut être le signe d'un {{locationType}} plus accessible.",
      },
    },
    nearest_park_area: {
      tag: {
        high: "Disponible à proximité",
      },
      qualifier: {
        high: "La présence de grands parcs à proximité peut être le signe d'un {{locationType}} plus attrayant.",
      },
    },
    bicycle_infrastructure_quality: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence d'une infrastructure de qualité pour les vélos peut être le signe d'un {{locationType}} plus accessible.",
      },
    },
    high_schools: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "Un accès facile aux écoles à proximité peut rendre le {{locationType}} plus attrayant.",
      },
    },
    primary_schools: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "Un accès facile aux écoles à proximité peut rendre le {{locationType}} plus attrayant.",
      },
    },
    quiet: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "Le peu de sources de bruit à proximité peut rendre le {{locationType}} plus attrayant.",
      },
    },
    daycares: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "Un accès facile aux services de garde à proximité peut rendre le {{locationType}} plus attrayant.",
      },
    },
    parks: {
      tag: {
        high: "Excellent accès",
      },
      qualifier: {
        high: "La présence de nombreux parcs à proximité peut rendre le {{locationType}} plus attrayant.",
      },
    },
  },
} as const;

export default namespace;
